import React from "react";
import { useTranslation } from "react-i18next";
import { useProductContext } from "../providers/ProductContextProvider";
import "./FeatureUnavailable.scss";

export function FeatureUnavailable({ feature, capability, reason }) {
  const { t } = useTranslation();
  const { locale } = useProductContext();

  return (
    <div className="feature-unavailable" data-locale={locale}>
      <div className="feature-unavailable__card">
        <h2>{t("international.featureUnavailableTitle", "Feature not available")}</h2>
        <p>
          {t(
            "international.featureUnavailableBody",
            "This feature is not available in your current language yet."
          )}
        </p>
        {(feature || capability || reason) && import.meta.env.DEV ? (
          <p className="feature-unavailable__debug">
            {[feature && `feature=${feature}`, capability && `capability=${capability}`, reason]
              .filter(Boolean)
              .join(" · ")}
          </p>
        ) : null}
      </div>
    </div>
  );
}

export default FeatureUnavailable;
